import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  signal
} from '@angular/core';
import { ModalGeneric } from '../../../ui/generics';
import { D_GLOBAL_MODAL } from '../../../core/directives';
import { environment } from '../../../../environments/environment';
import { IArticleVariant } from '../../../core/interfaces';
import { finalize } from 'rxjs/operators';
import { NotificationService } from '../../../core/services';
import * as moment from 'moment';
import { ArticlesService } from '../../../pages/articles/core/ArticlesService';

@Component({
    selector: 'app-change-mhd-modal',
    templateUrl: './change-mhd-modal.component.html',
    styleUrl: './change-mhd-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: D_GLOBAL_MODAL, useExisting: ChangeMhdModalComponent }],
    standalone: false
})
export class ChangeMhdModalComponent extends ModalGeneric {

  @Input() hideEanSearch = false;

  @Output() mhdChanged = new EventEmitter<IArticleVariant>();

  public isLoading = signal(false);
  public articleVariant: IArticleVariant;
  public newMhd: string;
  public readonly dateFormat = environment.defaultDateFormat;

  constructor(
    protected cdr: ChangeDetectorRef,
    private readonly _articlesService: ArticlesService,
    private readonly _notificationService: NotificationService,
  ) {
    super(cdr);
  }

  public onSearchChanged(ean: string): void {
    this.isLoading.set(true);

    this._articlesService.getArticleByEan(ean)
      .pipe(
        finalize(() => this.isLoading.set(false))
      )
      .subscribe({
        next: value => this.articleVariant = value,
        error: () => this._notificationService.pushError('Fehler', 'Fehler beim Laden des Artikels.')
      });
  }

  public saveNewMhd(): void {
    this.isLoading.set(true);
    const mhdDate = moment(this.newMhd);

    this._articlesService.updateMHD(
      this.articleVariant.id,
      this.newMhd && mhdDate.isValid() ? mhdDate.format('YYYY-MM-DD') : null
    ).pipe(
      finalize(() => this.isLoading.set(false))
    ).subscribe(() => {
      this.articleVariant.mhd = this.newMhd;
      this.newMhd = null;
      this.mhdChanged.emit(this.articleVariant);
      this._notificationService.pushSuccess('Erfolg', 'MHD korrekt aktualisiert.');
    }, () => {
      this._notificationService.pushError('Fehler', 'Fehler beim Aktualisieren der MHD.');
    });
  }

  public showModal(object: { articleVariant: IArticleVariant } = null) {
    super.showModal(object);

    if (object?.articleVariant) {
      this.articleVariant = object.articleVariant;
    }
  }

  public handleCancel(): void {
    this.articleVariant = null;
    this.newMhd = null;
    super.handleCancel();
  }
}
